import { RouteRecordRaw } from 'vue-router';
import { route } from '@/router/utils'
// import { allPermissions } from '@access/index'
// import { accessPermission } from '@/permissions/permissions'

// const {
//   STAFF: {
//     USER: {
//       VIEW
//     },
//   },
// } = allPermissions

const list = () => import('./List.vue')
const details = () => import('./details/Details.vue')

export const SELLERS_LIST_PAGE_NAME = 'cabinet:sellers'
export const SELLER_DETAILS_PAGE_NAME = 'cabinet:seller'

// URLs
export const SELLERS_LIST_PAGE_URL = ''
export const SELLER_DETAILS_PAGE_URL = 'details/:id?/'

export function createRoutes(options): RouteRecordRaw[] {
  return [
    route(SELLERS_LIST_PAGE_URL, list, SELLERS_LIST_PAGE_NAME, {
      meta: {
        breadcrumb: 'sellers',
        // ...accessPermission([VIEW], options),
      }
    }),
    route(SELLER_DETAILS_PAGE_URL, details, SELLER_DETAILS_PAGE_NAME, {
      meta: {
        breadcrumb: 'seller-details',
        parent: SELLERS_LIST_PAGE_NAME,
        // ...accessPermission([VIEW], options),
      }
    }),
  ]
}
